
import React from 'react';
// Styles
import StyleWrapper from './Wrapper';

const Avatar = (data) => {
    return (
        <div className="header-avatar">
            <span>{ "你好, " + data.name }</span>
        </div>
    );
};
const MenuItem = class extends React.Component {
    render() {
        return (
            <li onClick={ () => { this.props.history.push(this.props.route); } }>
                {this.props.children}
            </li>
        );
    }
};

export default class Menu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userName: "there"
        };
    }

    componentDidMount() {
        this.props.auth.getProfile((err, profile)=> {
            if (err === null) {
                let firstName = profile["http://gogochart.com/user_metadata"] ? profile["http://gogochart.com/user_metadata"].firstname : "";
                this.setState({
                    userName: firstName || profile.nickname
                });
            }
        });
    }

    render() {
        return (
            <StyleWrapper className="header-menu">
                <Avatar name={this.state.userName} />

                <div className="nav-bars">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                
                <nav>
                    <ul>
                        <MenuItem history={this.props.history} route={"/me/account"}>我的帐户</MenuItem>
                        <MenuItem history={this.props.history} route={"/me/billing"}>付款资料</MenuItem>
                        <MenuItem history={this.props.history} route={"/Campaign"}>广告项目列表</MenuItem>
                        <li onClick={ () => { this.props.auth.logout(); } }>登出</li>
                    </ul>
                </nav>
            </StyleWrapper>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/Headers/Menu/index.js